@if (!loading()) {
  <section class="cmc-box cmc-topic--verwaltung">
    <header class="cmc-box__head">
      <span class="cmc-box__icon"><mat-icon>calendar_today</mat-icon></span>
      <h2 class="cmc-box__title">{{ 'board.appointments.title_next_appointment' | translate }}</h2>
    </header>

    <div class="cmc-stack">
      @if (appointment(); as apt) {
        @if (apt.location) {
          <div class="cmc-info-row"><mat-icon>place</mat-icon><span>{{ apt.location.name }}</span></div>
        }
        <div class="cmc-info-row">
          <mat-icon>event</mat-icon>
          <span>
            @if (apt.weekdayNumber) {
              {{ getWeekday(apt.weekdayNumber.toString()) }}
            }
            {{ apt.date | date: 'dd.MM.yyyy' }}
          </span>
        </div>
        <div class="cmc-info-row"><mat-icon>schedule</mat-icon><span>{{ apt.begin }}</span></div>

        @if (!apt.fileCode) {
          <span class="cmc-status cmc-status--warning align-self-start">
            <mat-icon class="icon-14">warning</mat-icon>
            {{ 'board.appointments.hint_no_agenda' | translate }}
          </span>
        }
      } @else {
        <div class="cmc-info-row"><mat-icon>info</mat-icon><span>{{ 'board.appointments.hint_no_appointment' | translate }}</span></div>
      }
    </div>

    @if (appointment()?.fileCode && appointment()?.filename) {
      <div class="cmc-form-actions">
        <button mat-stroked-button
                (click)="deliverFile(appointment()!.fileCode!, 'board_agenda', appointment()!.filename!)"
                matTooltip="{{'common.action_download' | translate}}">
          <mat-icon>download</mat-icon>
          {{ 'board.appointments.label_download_agenda' | translate }}
        </button>
      </div>
    }
  </section>
}
